import { Checkbox, TableHeaderCell } from "semantic-ui-react";

type CheckboxTableHeaderCellProps = {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onToggle: () => void;
};

export const CheckboxTableHeaderCell = ({ label, checked, onToggle, disabled }: CheckboxTableHeaderCellProps) => (
  <TableHeaderCell>
    <div className="header-wrapper">
      <div className="select-all-wrapper">
        <Checkbox checked={checked} onChange={onToggle} disabled={disabled} />
      </div>
      <span className="header-tag">{label}</span>
    </div>
  </TableHeaderCell>
);
